import type { UpdateMeResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createMutation } from '~/shared/api'

import { mapUserFromApi } from './mappers/mapUserFromApi'
import { mapUserToApi, type UpdateUserInput } from './mappers/mapUserToApi'
import { UserQuery } from './UserQuery'

export type { UpdateUserInput } from './mappers/mapUserToApi'

/** PATCH /users/me — имя и/или пол (A1). */
export const UpdateUserMutation = createMutation<
  UpdateUserInput,
  UpdateMeResponse,
  ReturnType<typeof mapUserFromApi>
>({
  key: 'user.update',
  path: API_PATHS.user.me,
  method: 'PATCH',
  getBody: mapUserToApi,
  transform: mapUserFromApi,
  sideEffects: {
    invalidateQueries: [UserQuery],
  },
})
